export const getShingleLandingPath = (state) => {
  const params = new URLSearchParams();
  ["policyId", "firstName", "lastName", "email", "phone"].forEach((key) => {
    if (state[key]) {
      params.append(key, state[key]);
    }
  });
  return `/shingle-landing?${params.toString()}`;
};
